import {
  ChannelId,
  MakeTransferFormField as FormFields,
  PaymentOption,
} from '@make-transfer/types/common';

import { PaymentDetails } from './PaymentDetails';
import { DeliveryMethod } from '@app/common/types/enum/deliveryMethod';

const checkDate = (date?: Date | string) => {
  if (!date) return new Date();
  return new Date(date);
};

const checkNumber = (value?: number | string) : number | null => {
  if (!value) {
    return null;
  }

  return Number(value);
};

const getAccountNumber = (account: any) => {
  if (!account) return '';
  return (
    account.productId || account.subAccountId
      ? `${account.maskedMemberNumber} - ${account.productId || account.subAccountId}`
      : (account.maskedMemberNumber ?? '')
  );
};

export const getPaymentDetails = (
  values: any,
  channelId: ChannelId,
  paymentOption?: PaymentOption|null,
): PaymentDetails => Object.assign(new PaymentDetails(), {
  from: values[FormFields.FROM]?.name || '',
  to: values[FormFields.TO]?.name || '',
  fromAccountNumber: getAccountNumber(values[FormFields.FROM]),
  toAccountNumber: getAccountNumber(values[FormFields.TO]),
  fromAccountId: values[FormFields.FROM]?.id || '',
  fromAccountType: values[FormFields.FROM]?.type || '',
  toAccountId: values[FormFields.TO]?.id || '',
  toAccountType: values[FormFields.TO]?.type || '',
  amount: values[FormFields.AMOUNT] || 0,
  transferType: values[FormFields.TRANSFER_TYPE] || '',
  paymentOption: paymentOption?.id,
  isDynamicAmount: paymentOption?.isDynamicAmount,
  isPlaidRtp: values[FormFields.DELIVERY_METHOD] === DeliveryMethod.INSTANT,
  dynamicAmountDescription: paymentOption?.dynamicAmountDescription,
  paymentOptionDisplayName: paymentOption?.displayName,
  scheduledDate: checkDate(values[FormFields.SCHEDULED_DATE]),
  recurringStartDate: checkDate(values[FormFields.RECURRING_START_DATE]),
  recurringStartDate1: checkDate(values[FormFields.RECURRING_START_DATE_1]),
  recurringStartDate2: checkDate(values[FormFields.RECURRING_START_DATE_2]),
  recurringType: values[FormFields.RECURRING_TYPE] || '',
  recurringNumber: checkNumber(values[FormFields.RECURRING_NUMBER]) || 0,
  recurringEndDate: checkDate(values[FormFields.RECURRING_END_DATE]),
  memo: values[FormFields.MEMO] || '',
  channelId,
});
